module.exports = __webpack_public_path__ + "img/universkin-H.d3703e62.jpg";